<div>
  <p-panel header="The Home Component Bundled as a Web Component is Now Being Displayed">
    <csxwc-home></csxwc-home>
  </p-panel>
</div>
